import { buildLabelIndex, findLabelEntry, resolveLabel } from "./labelLookup";
import { MATERIAL_TERMS } from "./categoryLabel";

// Anzeigenamen der News-/Report-Sektoren (Tabelle sectors). Schlüssel =
// exakter Datenbankwert. Materialsektoren (material_sectors) und
// Produktsektoren stehen in MATERIAL_TERMS (utils/categoryLabel.js).
export const NEWS_SECTOR_TERMS = {
  "Arbeit & Arbeitsmarkt": { en: "Labor & Employment", zh: "劳动与就业" },
  "Bau & Infrastruktur": { en: "Construction & Infrastructure", zh: "建筑与基础设施" },
  "Bildung, Forschung & Entwicklung": { en: "Education, Research & Development", zh: "教育、研究与开发" },
  "Bildung & Wissenschaft": { en: "Education & Science", zh: "教育与科学" },
  "Chemie & Werkstoffe": { en: "Chemicals & Materials", zh: "化学与材料" },
  "Dienstleistungen": { en: "Services", zh: "服务业" },
  "Energie": { en: "Energy", zh: "能源" },
  "Energiepolitik & Klimawandel": { en: "Energy Policy & Climate Change", zh: "能源政策与气候变化" },
  "Energie & Ressourcen": { en: "Energy & Resources", zh: "能源与资源" },
  "Entsorgungswirtschaft": { en: "Waste Management", zh: "废弃物管理" },
  "Ernährung": { en: "Food & Nutrition", zh: "食品与营养" },
  "Finanzwesen & Recht": { en: "Finance & Law", zh: "金融与法律" },
  "Forschung & Innovation": { en: "Research & Innovation", zh: "研究与创新" },
  "Freizeit, Tourismus & Gastronomie": { en: "Leisure, Tourism & Hospitality", zh: "休闲、旅游与餐饮" },
  "Geschichte": { en: "History", zh: "历史" },
  "Gesellschaft": { en: "Society", zh: "社会" },
  "Gesellschaft & Soziales": { en: "Society & Social Affairs", zh: "社会与民生" },
  "Gesundheit & Medizin": { en: "Health & Medicine", zh: "健康与医疗" },
  "Gesundheit & Soziales": { en: "Health & Social Care", zh: "健康与社会服务" },
  "Handel & Konsumgüter": { en: "Retail & Consumer Goods", zh: "零售与消费品" },
  "IKT & Digitalisierung": { en: "ICT & Digitalization", zh: "信息通信技术与数字化" },
  "Immobilien & Wohnen": { en: "Real Estate & Housing", zh: "房地产与住房" },
  "Infrastruktur & Städtebau": { en: "Infrastructure & Urban Development", zh: "基础设施与城市发展" },
  "Innovation & Start-ups": { en: "Innovation & Start-ups", zh: "创新与初创企业" },
  "Internationale Beziehungen & Geopolitik": { en: "International Relations & Geopolitics", zh: "国际关系与地缘政治" },
  "Katastrophen & Krisen": { en: "Disasters & Crises", zh: "灾难与危机" },
  "Kulturpolitik & Religion": { en: "Cultural Policy & Religion", zh: "文化政策与宗教" },
  "Land- & Forstwirtschaft": { en: "Agriculture & Forestry", zh: "农业与林业" },
  "Maschinen- & Anlagenbau": { en: "Machinery & Plant Engineering", zh: "机械与设备制造" },
  "Medien & Kommunikation": { en: "Media & Communication", zh: "媒体与传播" },
  "Politik & Regierung": { en: "Politics & Government", zh: "政治与政府" },
  "Politik, Verwaltung & Entwicklung": { en: "Politics, Public Administration & Development", zh: "政治、行政与发展" },
  "Raumfahrt & Luftfahrt": { en: "Aerospace & Aviation", zh: "航天与航空" },
  "Recht & Justiz": { en: "Law & Justice", zh: "法律与司法" },
  "Rohstoffe": { en: "Raw Materials", zh: "原材料" },
  "Rohstoffe & Industrie": { en: "Raw Materials & Industry", zh: "原材料与工业" },
  "Sicherheit & Verteidigung": { en: "Security & Defense", zh: "安全与国防" },
  "Sport": { en: "Sports", zh: "体育" },
  "Technologie & Digitalisierung": { en: "Technology & Digitalization", zh: "技术与数字化" },
  "Transport & Logistik": { en: "Transport & Logistics", zh: "运输与物流" },
  "Umwelt & Entsorgung": { en: "Environment & Waste Management", zh: "环境与废物处理" },
  "Umwelt & Klima": { en: "Environment & Climate", zh: "环境与气候" },
  "Unternehmen & Märkte": { en: "Business & Markets", zh: "企业与市场" },
  "Verbraucherschutz": { en: "Consumer Protection", zh: "消费者保护" },
  "Verkehr & Mobilität": { en: "Transport & Mobility", zh: "交通与出行" },
  "Verwaltung & Entwicklung": { en: "Administration & Development", zh: "行政与发展" },
  "Wirtschaft & Finanzen": { en: "Economy & Finance", zh: "经济与金融" },
  "Wirtschaft & Unternehmen": { en: "Economy & Business", zh: "经济与企业" },
};

const SECTOR_INDEX = buildLabelIndex(NEWS_SECTOR_TERMS, MATERIAL_TERMS);

// Anzeigename eines Sektors (News-, Report-, Material- oder Produktsektor) in
// der Sprache `lang`. Unbekannte Werte kommen unverändert zurück.
export function translateSectorLabel(label, lang) {
  return resolveLabel(SECTOR_INDEX, label, lang);
}

export function hasSectorLabel(label) {
  return findLabelEntry(SECTOR_INDEX, label) != null;
}
